var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "custom-page" },
    [
      _vm.page && _vm.page.type === "Internal"
        ? _c(
            "v-container",
            { staticClass: "custom-page-container", attrs: { fluid: "" } },
            _vm._l(_vm.pageLayout, function(row, index) {
              return _c(
                "v-row",
                { key: index, attrs: { "no-gutters": "" } },
                _vm._l(row, function(col) {
                  return _c(
                    "v-col",
                    {
                      key: "key" + col.contentIndex,
                      staticClass: "custom-page-column",
                      attrs: { md: col.cols, cols: "12" }
                    },
                    [
                      _c("content-block", {
                        attrs: {
                          index: col.contentIndex,
                          content: _vm.page.content
                        }
                      })
                    ],
                    1
                  )
                }),
                1
              )
            }),
            1
          )
        : _vm.page && _vm.page.type === "iFrame"
        ? _c("div", { staticClass: "custom-page-iframe" }, [
            _c("iframe", {
              attrs: {
                src: _vm.page.hyperLink,
                title: _vm.page.title,
                scrolling: "auto"
              }
            })
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }